import { BOOKING_URL } from "./constants";

export const BookingLink = ({ className, testId, children }) => (
  <a className={className} href={BOOKING_URL} target="_blank" rel="noopener" data-testid={testId}>
    {children}
  </a>
);
